import _defineProperty from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { OFFER_ACTION_TYPES } from '../../actions/offer';
var initialState = {
  photosModal: {},
  isCalendarOpen: false
};
var offerReducer = function offerReducer() {
  var _payload$offerViews, _payload$offerViews$d, _payload$offerViews$d2;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case OFFER_ACTION_TYPES.GENERATE_GALLERY_GRID_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        photosModal: _objectSpread(_objectSpread({}, state.photosModal), {}, {
          photosGrid: payload.grid
        })
      });
    case OFFER_ACTION_TYPES.SET_PRICE_DETAILS_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        priceDetails: _objectSpread(_objectSpread({}, state.priceDetails), {}, {
          request: _objectSpread(_objectSpread({}, state.priceDetails.request), payload),
          error: null
        })
      });
    case OFFER_ACTION_TYPES.SET_PRICE_DETAILS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        priceDetails: _objectSpread(_objectSpread({}, state.priceDetails), payload)
      });
    case OFFER_ACTION_TYPES.SET_PRICE_DETAILS_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        priceDetails: _objectSpread(_objectSpread({}, state.priceDetails), {}, {
          data: payload.priceDetails
        })
      });
    case OFFER_ACTION_TYPES.SET_PRICE_DETAILS_DATA_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        priceDetails: _objectSpread(_objectSpread({}, state.priceDetails), {}, {
          isLoading: payload.isLoading
        })
      });
    case OFFER_ACTION_TYPES.SET_IS_CALENDAR_OPEN:
      return _objectSpread(_objectSpread({}, state), {}, {
        isCalendarOpen: payload.isCalendarOpen
      });
    case OFFER_ACTION_TYPES.SET_OFFER_VIEWS:
      return _objectSpread(_objectSpread({}, state), {}, {
        offerViews: (_payload$offerViews = payload.offerViews) === null || _payload$offerViews === void 0 ? void 0 : (_payload$offerViews$d = _payload$offerViews.data) === null || _payload$offerViews$d === void 0 ? void 0 : (_payload$offerViews$d2 = _payload$offerViews$d.attributes) === null || _payload$offerViews$d2 === void 0 ? void 0 : _payload$offerViews$d2.views
      });
    case OFFER_ACTION_TYPES.SET_OFFER_VIEWS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        offerViews: null
      });
    default:
      return state;
  }
};
export default offerReducer;